import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../providers/api";
import {
  cleanHandshakeData,
  reduceHandShake,
  cleanHandshakeData1
} from "../helpers";

const initialState = {
  isLoading: true
};

export const getHandshake = createAsyncThunk("get-handshake", async () => {
  const response = await api.handshake.getAll();
  return response?.Data;
});

const themeSlice = createSlice({
  name: "theme",
  initialState,
  extraReducers: {
    [getHandshake.fulfilled]: (state, action) => {
      const data = cleanHandshakeData(action.payload);
      const newState = {
        ...state,
        isLoading: false,
        Error: "",
        ...reduceHandShake(data),
        ...cleanHandshakeData1(action.payload),
        handshakeData: action.payload
      };
      return newState;
    },
    [getHandshake.pending]: state => {
      state.isLoading = true;
    },
    [getHandshake.rejected]: state => {
      state.isLoading = false;
      // addToast.error("error", {
      //   toastId: "error",
      // });
    }
  }
});

export default themeSlice.reducer;
